function cov_2h6wypbhkn() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Question.tsx";
  var hash = "ef2172b7fdf528d32b06255d8f2aaf3d5f6d447e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Question.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 48
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "ef2172b7fdf528d32b06255d8f2aaf3d5f6d447e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2h6wypbhkn = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2h6wypbhkn();
var Icon = (cov_2h6wypbhkn().s[0]++, {
  name: 'question',
  svg: "<path d=\"M12 5.5C10.3926 5.5 9.01846 6.51185 8.48571 7.93755C8.24406 8.58423 7.52392 8.91257 6.87724 8.67092C6.23056 8.42927 5.90222 7.70913 6.14387 7.06245C7.02986 4.69148 9.31582 3 12 3C15.4518 3 18.25 5.79822 18.25 9.25C18.25 12.2737 16.1028 14.7959 13.25 15.375V15.95C13.25 16.6404 12.6903 17.2 12 17.2C11.3096 17.2 10.75 16.6404 10.75 15.95L10.75 14.25C10.75 13.5623 11.3053 13.0044 11.9919 13L12 13C14.0711 13 15.75 11.3211 15.75 9.25C15.75 7.17893 14.0711 5.5 12 5.5Z\" fill=\"currentColor\"/>\n  <path d=\"M11.95 21.1C12.6403 21.1 13.2 20.5404 13.2 19.85C13.2 19.1596 12.6403 18.6 11.95 18.6C11.2596 18.6 10.7 19.1596 10.7 19.85C10.7 20.5404 11.2596 21.1 11.95 21.1Z\" fill=\"currentColor\"/>"
});
export default Icon;